<template>
  <div class="app-email-verification-modal">
    <b-modal :id="'emailVerificationModal' + _uid"
             data-qa="modal"
             v-model="showModal"
             @hide="markShown()"
             :hide-footer="modalHideFooter"
             :title="modalTitle"
             :static="modalStatic"
             header-bg-variant="custom"
             header-text-variant="custom"
             body-bg-variant="custom"
             body-text-variant="custom"
           footer-bg-variant="custom"
             footer-text-variant="custom"
    >
      <dyn-slot :slot-data="slotData"><slot><p>Ihre E-Mail-Adresse wurde noch nicht erfolgreich bestätigt.</p></slot></dyn-slot>
    </b-modal>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { BModal } from 'bootstrap-vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import DynSlot from '@/components/generic/DynSlot.vue'

export default {
  name: 'EmailVerificationModal',
  components: { BModal, DynSlot },
  props: {
    modalTitle: {
      type: String,
      default: 'Achtung'
    },
    modalHideFooter: {
      type: Boolean,
      default: true
    },
    modalStatic: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentCustomer: {
        email: '[[E-Mail-Adresse]]',
        emailVerified: true
      }
    }
  },
  computed: {
    showModal: {
      get () {
        if (this.$store.getters.wasModalShown('emailVerified')) {
          return false
        }
        return !this.currentCustomer.emailVerified
      },
      set () {
        // no manual set
      }
    },
    slotData () {
      return {
        currentCustomer: this.currentCustomer
      }
    }
  },
  methods: {
    markShown () {
      this.$store.commit('markModalShown', 'emailVerified')
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query{
        currentCustomer {
          email
          emailVerified
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
